import api from './api'
const SERVER = {
  entranceUrl: '/operations/campsite/v2/enroll/entrance',
  examineUrl: '/operations/campsite/v2/enroll/examine',
  createLoadUrl: '/operations/campsite/v2/enroll/createLoad',
  checkIsCanEnrollUrl: '/operations/campsite/v2/enroll/checkIsCanEnroll',
  createUrl: '/operations/campsite/v2/enroll/create'
}

function entranceList (params) {
  return api.get(SERVER.entranceUrl, { params }).then(res => {
    return res
  })
}

function examine (params) {
  return api.post(SERVER.examineUrl, params).then(res => {
    return res
  })
}

function createLoadOptions (params) {
  return api.get(SERVER.createLoadUrl, { params }).then(res => {
    return res
  })
}

function checkIsCanEnroll (params) {
  return api.post(SERVER.checkIsCanEnrollUrl, params).then(res => {
    return res
  })
}

function create (params) {
  return api.post(SERVER.createUrl, params).then(res => {
    return res
  })
}

export default {
  entranceList,
  examine,
  createLoadOptions,
  checkIsCanEnroll,
  create
}
